import { render, staticRenderFns } from "./mProductCard.vue?vue&type=template&id=7947981d&scoped=true"
import script from "./mProductCard.vue?vue&type=script&lang=js"
export * from "./mProductCard.vue?vue&type=script&lang=js"
import style0 from "./mProductCard.vue?vue&type=style&index=0&id=7947981d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7947981d",
  null
  
)

export default component.exports